import { useTranslation as e } from "../../i18n.mjs";
import { ToolbarSelect as t } from "../../components/content-controls/toolbar-select.mjs";
import { ToolbarSheetSelect as n } from "../../components/content-controls/toolbar-sheet-select.mjs";
import { isImageSelected as r } from "../image-extension/utils/is-image-selected.mjs";
import { TextLevelEnum as i } from "./text-level-enum.mjs";
import { getCurrentTextLevelValue as a, getTextLevelValues as o } from "./utils/text-level.mjs";
import { useEditorState as s } from "@tiptap/react";
import { useMemo as c } from "react";
import { jsx as l, jsxs as u } from "react/jsx-runtime";
import { Heading01Icon as d } from "@systemeio/icons";
//#region src/extensions/heading-extension/use-heading-extension-toolbar.tsx
var f = (f) => {
	let { t: p } = e(), m = s({
		editor: f,
		selector: ({ editor: e }) => ({
			isEditable: e?.options.editable ?? !1,
			textLevel: a(e),
			isImageSelected: r(e)
		})
	}), h = m?.textLevel, g = o(p).find((e) => e.value === h)?.label, _ = !m?.isEditable || !!m?.isImageSelected;
	return c(() => {
		let e = (e) => {
			if (!f) return null;
			if (e === i.Default) return f.chain().focus().setParagraph().run();
			f.chain().focus().toggleHeading({ level: e }).run();
		};
		return {
			toolbarRender: /* @__PURE__ */ u(t, {
				disabled: _,
				label: p("text_level.title"),
				labelledByContent: !0,
				onChange: e,
				options: o(p),
				value: h,
				children: [/* @__PURE__ */ l(d, {}), g]
			}),
			sheetRender: /* @__PURE__ */ l(n, {
				disabled: _,
				icon: /* @__PURE__ */ l(d, {}),
				label: p("text_level.title"),
				onChange: e,
				options: o(p),
				value: h
			})
		};
	}, [
		g,
		h,
		f,
		_,
		p
	]);
};
//#endregion
export { f as useHeadingExtensionToolbar };
